module.exports = require("./ro.d.ts");